module.exports = "<div class=\"panel__refresh medium-spinner active-spinner\">\n  <img src=\"assets/images/img-loader.gif\">\n</div>"